export default "__VITE_ASSET__CpNZZfX$__"